<ng-container *ngIf="isAuthenticated$ | async">
    <button dpadSelectable #followElement class="btn-v2" *ngIf="follows$ | async as follows" [class.active]="!follows.includes(creatorTeamId)" (click)="toggleFollow(follows.includes(creatorTeamId), creatorTeamId)">
        {{ follows.includes(creatorTeamId) ? 'Unfollow' : 'Follow' }}
    </button>
</ng-container>

